'use client';
import { FC, PropsWithChildren } from 'react';
import { CatTab } from '@blocks-react/components/Tab';
import { CatTabs } from '@blocks-react/components/Tabs';
import { CatTabPanel } from '@blocks-react/components/TabPanel';
import { CatTabsProp } from '../types';
import { BlocksTabChange } from '@blocks-web-components/events/blocks-tab-change';
import { useFormContext } from 'react-hook-form';
import { REQUEST_SERVICE_FORM_ATTRIBUTES, TAB_INDEX } from '../constants';
import { v4 as uuid } from 'uuid';

export const RequestServiceDateTabs: FC<PropsWithChildren<CatTabsProp>> = ({
  tabs,
  onBlTabChange
}) => {
  const { setValue, clearErrors, watch, unregister, register } =
    useFormContext();
  const preferredType = watch('preferredDateTime.type');
  const activeIndex =
    preferredType === REQUEST_SERVICE_FORM_ATTRIBUTES.PREF_DATE_TYPE.CUSTOM
      ? TAB_INDEX.CUSTOM
      : TAB_INDEX.ASAP;

  const onBlTabChangeHandler = (tabEvent: BlocksTabChange): void => {
    if (onBlTabChange) onBlTabChange(tabEvent);
    let prefDateType = REQUEST_SERVICE_FORM_ATTRIBUTES.PREF_DATE_TYPE.ASAP;
    if (tabEvent.detail.activeTabIndex === TAB_INDEX.CUSTOM) {
      prefDateType = REQUEST_SERVICE_FORM_ATTRIBUTES.PREF_DATE_TYPE.CUSTOM;
      register('preferredDateTime.dates');
    } else {
      unregister('preferredDateTime.dates');
    }
    clearErrors('preferredDateTime');
    setValue('preferredDateTime.type', prefDateType, { shouldDirty: true });
  };
  return (
    <CatTabs
      variant="contrast"
      onBlTabChange={onBlTabChangeHandler}
      behavior="responsive-full-width"
      data-testid="prefered-date-tabs"
      activeIndex={activeIndex}
    >
      {tabs.map((tab) => (
        <>
          <CatTab
            key={uuid()}
            className={tab.classname}
            ariaLabelledBy={tab.ariaLable}
            data-testid={tab.tabName}
          >
            {tab.tabName}
          </CatTab>
          <CatTabPanel slot="panel">{tab.tabPanel}</CatTabPanel>
        </>
      ))}
    </CatTabs>
  );
};
